'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var _ = require('lodash');
var LocalizeMixin = require('../../localization/CommonLocalizationMixin');

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    propTypes: {
        currentFilters: PropTypes.array.isRequired
    },
    getInitialState: function getInitialState() {
        return {};
    },
    checkboxHandler: function checkboxHandler(item) {
        if (this.props.checkboxHandler) {
            this.props.checkboxHandler(item);
        }
    },
    clearHandler: function clearHandler() {
        if (this.props.clearHandler) {
            this.props.clearHandler();
        }
    },
    doneHandler: function doneHandler() {
        if (this.props.doneHandler) {
            this.props.doneHandler();
        }
    },
    isFilterActive: function isFilterActive(filterName) {
        return _.indexOf(this.props.currentFilters, filterName) > -1;
    },
    createCheckbox: function createCheckbox(filterName, id, imageName, text, position) {
        var className = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

        return React.createElement(
            'div',
            { className: 'checkboxes ' + className },
            React.createElement(
                'label',
                null,
                React.createElement('input', { checked: this.isFilterActive(filterName), type: 'checkbox',
                    className: 'filter-option-checkbox', id: id, tabIndex: '-1',
                    onChange: this.checkboxHandler.bind(null, filterName),
                    'aria-posinset': position, 'aria-setsize': '8'
                }),
                React.createElement('img', { src: '/images/common/amenities/ic_brown_' + imageName + '_normal.png', role: 'icon', alt: '' }),
                React.createElement(
                    'span',
                    { className: 'label-text' },
                    text
                )
            )
        );
    },
    handleFilterKeyDown: function handleFilterKeyDown(e) {
        var parent = document.activeElement.parentNode.parentNode;
        switch (e.keyCode) {
            case 38:
                // up arrow
                e.preventDefault();
                if (parent.previousSibling) {
                    var checkbox = parent.previousSibling.querySelector('.filter-option-checkbox');
                    if (checkbox) {
                        checkbox.focus();
                    }
                }
                break;
            case 40:
                //down arrow
                e.preventDefault();
                if (!document.activeElement.className.match(/filter-option-checkbox/)) {
                    var checkbox = document.querySelector('.filter-option-checkbox');
                    checkbox.focus();
                } else {
                    if (parent.nextSibling) {
                        var checkbox = parent.nextSibling.querySelector('.filter-option-checkbox');
                        if (checkbox) {
                            checkbox.focus();
                        }
                    }
                }
                break;
            default:
                break;
        }
    },
    render: function render() {
        var filterStyle = {
            color: '#8D6E63'
        };

        return React.createElement(
            'div',
            { className: 'filter-locations', onKeyDown: this.handleFilterKeyDown, role: 'listbox',
                'aria-multiselectable': 'true', 'aria-labelledby': 'filter_title', 'aria-orientation': 'horizontal', tabIndex: '0' },
            React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    React.createElement(
                        'h2',
                        { id: 'filter_title', style: filterStyle },
                        this.getLocalizedText('location_page_filter_title')
                    )
                )
            ),
            React.createElement(
                'div',
                { className: 'options' },
                this.createCheckbox('hasMobileOrder', 'has-mobile-order-checkbox', 'mobile', this.getLocalizedText('location_page_filter_mobile_ordering'), 1),
                this.createCheckbox('hasMobilePay', 'has-mobile-pay-checkbox', 'mobilepay', this.getLocalizedText('location_page_filter_mobile_payment'), 2),
                this.createCheckbox('hasWifi', 'has-wifi-checkbox', 'wifi', this.getLocalizedText('location_page_filter_wifi'), 3),
                this.createCheckbox('isOpenLate', 'is-open-late-checkbox', 'late', this.getLocalizedText('location_page_filter_open_late'), 4),
                this.createCheckbox('isOpen24Hours', 'is-24h-checkbox', 'always_open', this.getLocalizedText('location_page_filter_open_24_hours'), 5),
                this.createCheckbox('hasBreakfast', 'breakfast-checkbox', 'breakfast', this.getLocalizedText('location_page_filter_breakfast'), 6),
                this.createCheckbox('hasCokeFreestyle', 'coke-freestyle-checkbox', 'freestyle', React.createElement('img', { src: '/images/common/amenities/img_freestyle_logo.png', alt: this.getLocalizedText('location_page_filter_coke_freestyle') }), 7, 'coke-freestyle'),
                this.createCheckbox('isFavorite', 'favorite-checkbox', 'favorite_location', this.getLocalizedText('location_page_filter_is_favorite'), 8)
            ),
            React.createElement(
                'div',
                { className: 'row button-container-small' },
                React.createElement('div', { className: 'col-xs-12' })
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/CheckboxContent.js
// module id = 798
// module chunks = 0